import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

/**
 * Marketing `data-analytics-event` payloads for the header logo and auth CTAs, enumerated in one place
 * so the exact per-CTA events are reviewable (parity risk: "enumerate per-CTA analytics").
 *
 * These use the shared `getAnalyticsEvent` marketing shape (`{location, action, context, tag, label}`,
 * label auto-derived as `action_tag_context_location`) — the same helper the sibling `MarketingNavigation`
 * links use — rather than the legacy `{category, action, label}` shape. The Hydro `authentication.click`
 * funnel is tracked separately via the server-signed `data-hydro-click` attributes.
 */
const LOCATION = 'header'
const CONTEXT_AUTH = 'auth cta'

export const logoAnalyticsEvent = getAnalyticsEvent({
  action: 'Homepage',
  tag: 'link',
  context: 'logo',
  location: LOCATION,
})

export const signInAnalyticsEvent = getAnalyticsEvent({
  action: 'Sign in',
  tag: 'link',
  context: CONTEXT_AUTH,
  location: LOCATION,
})

export const signUpAnalyticsEvent = getAnalyticsEvent({
  action: 'Sign up',
  tag: 'link',
  context: CONTEXT_AUTH,
  location: LOCATION,
})

export const dashboardAnalyticsEvent = getAnalyticsEvent({
  action: 'Dashboard',
  tag: 'link',
  context: CONTEXT_AUTH,
  location: LOCATION,
})

/**
 * The search trigger intentionally keeps the exact legacy Blackbird event shape
 * (`action: searchbar, tag: input, context: global, location: navbar`) rather than the
 * marketing-header `location: header` convention the auth CTAs adopted, so existing search-open
 * dashboards keep reporting uninterrupted across the React migration.
 */
export const searchAnalyticsEvent = getAnalyticsEvent({
  action: 'searchbar',
  tag: 'input',
  context: 'global',
  location: 'navbar',
})
